// apiRequestManager.js
import axios from "axios";

const controllers = new Map();

/**
 * Generates a unique key per request
 * You can customize this based on your needs
 */
const getRequestKey = (method: string, url: string) => {
  return `${method}:${url}`;
};

export const apiRequest = async ({
  method = "get",
  url,
  data,
  params,
  headers,
  key, // optional override key
}: {
  method: string;
  url: string;
  data?: any;
  params?: any;
  headers?: any;
  key?: string;
}) => {
  const requestKey = key || getRequestKey(method, url);

  // Abort previous request with same key
  if (controllers.has(requestKey)) {
    controllers.get(requestKey).abort();
  }

  const controller = new AbortController();
  controllers.set(requestKey, controller);

  try {
    const response = await axios({
      method,
      url,
      data,
      params,
      headers,
      signal: controller.signal,
    });

    return response;
  } catch (error: any) {
    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
      console.debug(`Request canceled: ${requestKey}`);
      return; // or throw if you want upstream handling
    }
    throw error;
  } finally {
    controllers.delete(requestKey);
  }
};